import React, { useEffect, useRef, useState, createContext } from "react";
import { Model } from "flexlayout-react";

export const LayoutContext = createContext(undefined);

export const LayoutProvider = ({ children, model }) => {
  const layoutRef = useRef();

  const [state, setState] = useState({ refresh: true });

  useEffect(() => {
    if (model) {
      const defaultState = {
        model: Model.fromJson(model),
        layout: layoutRef,
      };
      setState(defaultState);
    }
  }, [model]);

  return state ? (
    <LayoutContext.Provider value={[state, setState]}>
      {children}
    </LayoutContext.Provider>
  ) : null;
};
